





































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Caretaker, BankTransfer, Budget, BudgetMove, MultiChoiceCardOrder } from '@/models'
import Pagination from '@/components/Pagination/index.vue'
import { Form } from 'element-ui/types/element-ui'
import { cancelCredit, validatePending } from '@/api/budget_moves'
import { createRefund } from '@/api/budgets'
import { sendEmail, generate } from '@/api/deposit_invoices'
import moment from 'moment'

@Component({
  name: 'Budget',
  components: {
    Pagination,
    DirectUpload: () => import('@/components/DirectUpload/index.vue')
  }
})
export default class extends Vue {
  @Prop({ required: true }) caretaker!: Caretaker

  private dialogFormVisible = false
  private newBankTransfer = new BankTransfer({ manageable: this.caretaker })
  private formKey = 0
  private createBankTransferLoading = false

  private orderOptions: MultiChoiceCardOrder[] = []
  private ordersLoading = false
  private searchOrdersTimeout: ReturnType<typeof setTimeout> | null = null

  private motifMaxLength = 1000

  private cancelCreditDialogVisible = false
  private cancelCreditComment = ''
  private cancelCreditLoading = false
  private cancelCreditTarget: BudgetMove | null = null

  private refundDialogVisible = false
  private refundAmount = ''
  private refundComment = ''
  private refundLoading = false

  private sendingInvoiceEmailId: string | null = null
  private downloadingInvoiceId: string | null = null

  private validateDialogVisible = false
  private validateTarget: BudgetMove | null = null
  private validateReceivedAmount = ''
  private validateReference = ''
  private validateSendAt: Date | null = null
  private validateComment = ''
  private validateLoading = false
  private validateProofOfPaymentSignedId: string | null = null
  private validateProofOfPaymentBlob: any = null

  private typeFilter: string[] = []
  private typeOptions = [
    { value: 'bank_transfer', label: 'Virement bancaire' },
    { value: 'pending_bank_transfer', label: 'Virement en attente' },
    { value: 'assigned_bank_transfer', label: 'Virement bancaire affecté' },
    { value: 'refund', label: 'Remboursement' },
    { value: 'dotation', label: 'Dotation' }
  ]

  private kindLabels: Record<string, string> = {
    credit: 'Crédit',
    debit: 'Débit',
    cancel_credit: 'Annulation de crédit',
    refund: 'Remboursement',
    issuance_fees: "Frais d'émission",
    loading_fees: 'Frais de chargement'
  }

  budget: Budget | null = null
  budgetLoading = false

  budgetMoves: BudgetMove[] = []
  totalBudgetMoves = 0
  budgetMovesLoading = false

  listQuery = {
    page: 1,
    limit: 10
  }

  created() {
    this.getBudget()
  }

  private async getBudget() {
    this.budgetLoading = true

    const { data } =
      await Budget
        .where({ caretakerId: this.caretaker.id })
        .first()

    this.budget = data
    this.budgetLoading = false

    this.getBudgetMoves()
  }

  private async getBudgetMoves() {
    if (!this.budget) return

    this.budgetMovesLoading = true

    const { data, meta } =
      await BudgetMove
        .where({ budgetId: this.budget.id, type: this.typeFilter.length ? this.typeFilter : undefined })
        .includes(['source', 'multiChoiceCardOrder'])
        .page(this.listQuery.page)
        .per(this.listQuery.limit)
        .order({ createdAt: 'desc' })
        .stats({ total: 'count' })
        .all()

    this.budgetMoves = data
    this.totalBudgetMoves = meta.stats.total.count
    this.budgetMovesLoading = false
  }

  private handleTypeFilterChange() {
    this.listQuery.page = 1
    this.getBudgetMoves()
  }

  private openCreateDialog() {
    this.newBankTransfer = new BankTransfer({ manageable: this.caretaker, pending: true, reserved: false, orderDate: moment().format('YYYY-MM-DD') })
    this.resetOrderReference()
    this.formKey++
    this.dialogFormVisible = true
  }

  private openEditDialog(row: BudgetMove) {
    this.newBankTransfer = row.source
    this.newBankTransfer.reserved = row.reserved
    this.resetOrderReference()

    if (row.multiChoiceCardOrder) {
      this.orderOptions = [row.multiChoiceCardOrder]
      this.newBankTransfer.multiChoiceCardOrderId = row.multiChoiceCardOrder.id
    }

    this.formKey++
    this.dialogFormVisible = true
  }

  private resetOrderReference() {
    this.orderOptions = []
  }

  get createDialogTitle() {
    if (!this.newBankTransfer.id) return 'Ajouter un acompte'

    return this.newBankTransfer.pending ? 'Modifier le virement en attente' : 'Modifier le virement'
  }

  private isPending(row: BudgetMove) {
    return row.sourceType === 'BankTransfer' && !!row.source.pending
  }

  private orderReferenceLabel(row: BudgetMove) {
    if (row.sourceType !== 'BankTransfer') return '—'

    return row.source.orderReference || '—'
  }

  private isAssignedToOrder(row: BudgetMove) {
    return this.orderReferenceLabel(row).startsWith('CMD-')
  }

  private orderDateLabel(row: BudgetMove) {
    if (row.sourceType !== 'BankTransfer' || !row.source.orderDate) return '—'

    return moment(row.source.orderDate).format('L')
  }

  private openValidateDialog(row: BudgetMove) {
    this.validateTarget = row
    this.validateReceivedAmount = String(row.amount)
    this.validateReference = ''
    this.validateSendAt = null
    this.validateComment = ''
    this.validateProofOfPaymentSignedId = null
    this.validateProofOfPaymentBlob = null
    this.validateDialogVisible = true
  }

  get validateReceivedAmountTooLow(): boolean {
    if (!this.validateTarget || this.validateReceivedAmount === '') return false

    return parseFloat(this.validateReceivedAmount) < this.validateTarget.amount
  }

  private handleValidateProofUpload(file: any) {
    this.validateProofOfPaymentSignedId = file.blob.signed_id
    this.validateProofOfPaymentBlob = file.blob
  }

  private async handleValidatePending() {
    if (!this.validateTarget || !this.validateSendAt) return

    this.validateLoading = true

    try {
      await validatePending(
        this.validateTarget.id,
        this.validateReceivedAmount,
        this.validateReference,
        this.validateSendAt.toISOString(),
        this.validateComment
      )

      if (this.validateProofOfPaymentSignedId) {
        const bankTransfer = this.validateTarget.source
        bankTransfer.proofOfPayment = this.validateProofOfPaymentSignedId
        await bankTransfer.save()
      }
    } catch (err: any) {
      const errors = err?.response?.data?.errors
      this.$notify({
        title: 'Erreur',
        message: errors?.length ? errors[0].detail : 'Validation impossible',
        type: 'error',
        duration: 3000
      })
      this.validateLoading = false
      return
    }

    this.$notify({
      title: 'Succès',
      message: "Le crédit d'acompte a été créé",
      type: 'success',
      duration: 2000
    })

    this.validateLoading = false
    this.validateDialogVisible = false
    this.getBudget()
  }

  private createBudget() {
    const isNew = !this.newBankTransfer.id;

    (this.$refs.dataForm as Form).validate(async(valid) => {
      this.createBankTransferLoading = true
      if (valid) {
        const data = this.newBankTransfer
        try {
          await data.save({ with: ['manageable.id'] })

          this.$notify({
            title: isNew ? 'Budget Created' : 'Virement modifié',
            message: isNew ? 'Virement en attente créé' : 'Le virement a été mis à jour',
            type: 'success',
            duration: 2000
          })

          this.newBankTransfer = new BankTransfer({ manageable: this.caretaker, pending: true, reserved: false, orderDate: moment().format('YYYY-MM-DD') })
          this.resetOrderReference()
          this.formKey++

          this.getBudget()
        } catch (err) {
          this.createBankTransferLoading = false
        }
      }
      this.createBankTransferLoading = false
      this.dialogFormVisible = false
    })
  }

  private async getOrderSuggestions(queryString: string, cb: any) {
    if (!queryString) {
      cb([])
      return
    }

    const { data } = await MultiChoiceCardOrder
      .where({ caretakerId: this.caretaker.id, number: { prefix: queryString }, status: { '!eq': 'paid' } })
      .all()

    cb(data.map(order => ({ value: order.number })))
  }

  private searchOrders(queryString: string) {
    if (this.searchOrdersTimeout) clearTimeout(this.searchOrdersTimeout)

    if (!queryString) {
      this.orderOptions = []
      return
    }

    this.searchOrdersTimeout = setTimeout(async() => {
      this.ordersLoading = true
      try {
        const { data } = await MultiChoiceCardOrder
          .where({ caretakerId: this.caretaker.id, number: { prefix: queryString }, status: { '!eq': 'paid' } })
          .all()

        this.orderOptions = data
      } finally {
        this.ordersLoading = false
      }
    }, 500)
  }

  private handleReservedChange(value: boolean) {
    if (value) return

    this.newBankTransfer.multiChoiceCardOrderId = ''
    this.resetOrderReference()
  }

  // Creation only: linking a real order makes this a CMD-type acompte (reserved for
  // that order); leaving it empty keeps it a free ALI-type appro (not reserved, usable
  // for any order) — see App::BankTransfer's linked_order/generate_order_reference.
  private handleOrderLinkChange(orderId: string) {
    this.newBankTransfer.reserved = !!orderId
  }

  private sourceTypeLabel(row: BudgetMove) {
    if (row.sourceType === 'BankTransfer') return row.source.pending ? 'Virement en attente' : 'Virement bancaire'
    if (row.kind === 'refund') return 'Remboursement'
    return 'Dotation'
  }

  private kindLabel(row: BudgetMove) {
    return this.kindLabels[row.kind] || row.kind || '—'
  }

  private referenceLabel(row: BudgetMove) {
    if (row.sourceType !== 'BankTransfer') return '—'

    return row.source.reference || '—'
  }

  private motifText(row: BudgetMove) {
    if (row.kind === 'cancel_credit' || row.kind === 'refund') return row.comment || ''
    if (row.sourceType === 'BankTransfer') return row.source.comment || ''
    return ''
  }

  private openRefundDialog() {
    this.refundAmount = ''
    this.refundComment = ''
    this.refundDialogVisible = true
  }

  private async handleDownloadInvoice(row: BudgetMove) {
    if (!row.depositInvoiceId) return

    this.downloadingInvoiceId = row.depositInvoiceId

    try {
      const response: any = await generate(row.depositInvoiceId)
      window.open(response.file_url, '_blank')
    } catch (err: any) {
      const errors = err?.response?.data?.errors
      this.$notify({
        title: 'Erreur',
        message: errors?.length ? errors[0].detail : 'Génération du PDF impossible',
        type: 'error',
        duration: 3000
      })
    }

    this.downloadingInvoiceId = null
  }

  private async handleSendInvoiceEmail(row: BudgetMove) {
    if (!row.depositInvoiceId) return

    this.sendingInvoiceEmailId = row.depositInvoiceId

    try {
      await sendEmail(row.depositInvoiceId)
      this.$notify({
        title: 'Succès',
        message: "Facture d'acompte envoyée par email",
        type: 'success',
        duration: 2000
      })
    } catch (err: any) {
      const errors = err?.response?.data?.errors
      this.$notify({
        title: 'Erreur',
        message: errors?.length ? errors[0].detail : "Envoi de la facture impossible",
        type: 'error',
        duration: 3000
      })
    }

    this.sendingInvoiceEmailId = null
  }

  private async handleRefund() {
    if (!this.budget) return

    this.refundLoading = true

    try {
      await createRefund(this.budget.id, parseFloat(this.refundAmount), this.refundComment)
    } catch (err: any) {
      const errors = err?.response?.data?.errors
      this.$notify({
        title: 'Erreur',
        message: errors?.length ? errors[0].detail : 'Remboursement impossible',
        type: 'error',
        duration: 3000
      })
      this.refundLoading = false
      return
    }

    this.$notify({
      title: 'Succès',
      message: 'Remboursement effectué',
      type: 'success',
      duration: 2000
    })

    this.refundLoading = false
    this.refundDialogVisible = false
    this.getBudget()
  }

  private openCancelCreditDialog(row: BudgetMove) {
    this.cancelCreditTarget = row
    this.cancelCreditComment = ''
    this.cancelCreditDialogVisible = true
  }

  private async handleCancelCredit() {
    if (!this.cancelCreditTarget) return

    this.cancelCreditLoading = true

    try {
      await cancelCredit(this.cancelCreditTarget.id, this.cancelCreditComment)
    } catch (err: any) {
      const errors = err?.response?.data?.errors
      this.$notify({
        title: 'Erreur',
        message: errors?.length ? errors[0].detail : 'Annulation impossible',
        type: 'error',
        duration: 3000
      })
      this.cancelCreditLoading = false
      return
    }

    this.$notify({
      title: 'Succès',
      message: 'Crédit annulé',
      type: 'success',
      duration: 2000
    })

    this.cancelCreditLoading = false
    this.cancelCreditDialogVisible = false
    this.getBudget()
  }
}
